import type {ThemeAndAnyColor} from '../../../../../styles';
import type {SelectV2} from '../../Select.v2';

import {Icon} from '../../../../Icon';
import {type SelectSingleValueV2} from '../SelectSingleValue.v2';

export const useSelectV2OptionIcon = ({
  data,
  textColor,
}: {
  data: SelectSingleValueV2.Props['data'];
  textColor: ThemeAndAnyColor;
}) => {
  const renderIcon = () => {
    const optionData = data as SelectV2.SingleSelectOption;

    if (!optionData.icon) {
      return null;
    }

    const {color, size, svg} = optionData.icon;

    if (!svg) {
      // eslint-disable-next-line no-console
      console.error('Icon is not a valid svg');

      return null;
    }

    const iconColor = color || textColor;

    return <Icon color={iconColor} size={size} svg={svg} />;
  };

  return {
    renderIcon,
    textColor,
  };
};
